import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Hero from "@/pages/home/components/Hero";
import MarqueeStrip from "@/pages/home/components/MarqueeStrip";
import ServicesSection from "@/pages/home/components/ServicesSection";
import FleetSection from "@/pages/home/components/FleetSection";
import HowToLeaseSection from "@/pages/home/components/HowToLeaseSection";
import PricingSection from "@/pages/home/components/PricingSection";
import ServiceCenterSection from "@/pages/home/components/ServiceCenterSection";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";
import FaqSection from "@/pages/home/components/FaqSection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <ServicesSection />
        <FleetSection />
        <HowToLeaseSection />
        <PricingSection />
        <ServiceCenterSection />
        <TestimonialsSection />
        <FaqSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}